<template>
  <v-btn class="px-0" rounded text @click="dialogModel = true" v-show="title != ''">
    <sig-help-dialog :dialogModel="dialogModel" :title="title" :message="message" @close="dialogModel = false" />
    <div v-show="showNeedHelp" class="sigfloButtonSmall300 black--text text-capitalize" v-if="logoSide == 'right'">
      Need Help?
    </div>
    <div class="sigHelpLogo">
      <v-img src="@/assets/images/sigfloSymbolPurple.svg" width="32" height="34" class="mx-3"></v-img>
    </div>
    <div v-show="showNeedHelp" class="sigfloButtonSmall300 black--text text-capitalize" v-if="logoSide == 'left'">
      Need Help?
    </div>
  </v-btn>
</template>

<script>
  import { mapState } from 'vuex';
  import sigHelpDialog from './SigHelpDialog.vue';

  export default {
    components: {
      sigHelpDialog
    },
    props: {
      logoSide: {
        type: String,
        default: 'right'
      },
      title: {
        type: String,
        required: false
      },
      message: {
        type: String,
        required: false
      },
      showNeedHelp: {
        type: Boolean,
        default: true
      },
      size: {
        type: String,
        default: 'small'
      }
    },
    data() {
      return {
        dialogModel: false
      };
    },
    computed: {
      ...mapState(['configurator'])
    }
  };
</script>

<style scoped></style>
